module.exports = __webpack_public_path__ + "img/image129.4e27b1d9.jpg";